import { Text, TouchableOpacity, View } from 'react-native';
import { buildAppInviteShareContent } from '../invite';
import { shareContent } from '../platform/share';
import { fallbackHandleFromPlayer } from '../profile';
import { colors, styles } from '../theme';
import type { BootstrapData, Translation } from '../types';
import { AppIcon } from './AppIcon';

type PlayerRef = Pick<BootstrapData['player'], 'name' | 'handle' | 'id'>;

type InviteFriendCardProps = {
  player: PlayerRef;
  title: string;
  copy: string;
  buttonLabel: string;
  searchName?: string;
  shareLabels: Pick<Translation, 'inviteShareTitle' | 'inviteShareMessage' | 'inviteShareMessageNamed'>;
  onShared?: (result: 'shared' | 'copied') => void;
  onError?: () => void;
};

export function InviteFriendCard({
  player,
  title,
  copy,
  buttonLabel,
  searchName,
  shareLabels,
  onShared,
  onError,
}: InviteFriendCardProps) {
  const handle = fallbackHandleFromPlayer(player);

  async function handleInvite() {
    try {
      const result = await shareContent(
        buildAppInviteShareContent({
          inviterName: player.name,
          inviterHandle: handle,
          friendName: searchName,
        }, shareLabels),
      );
      onShared?.(result);
    } catch {
      onError?.();
    }
  }

  return (
    <View style={styles.inviteCard}>
      <View style={styles.inviteCardHeader}>
        <View style={styles.inviteCardIconWrap}>
          <AppIcon name="user-plus" size={20} color={colors.interactiveStrong} />
        </View>
        <View style={styles.inviteCardCopy}>
          <Text style={styles.cardTitle}>{title}</Text>
          <Text style={styles.muted}>{copy}</Text>
        </View>
      </View>
      <TouchableOpacity
        accessibilityRole="button"
        style={styles.inviteCardButton}
        onPress={() => void handleInvite()}
      >
        <AppIcon name="share" size={18} color={colors.text} />
        <Text style={styles.inviteCardButtonText}>{buttonLabel}</Text>
      </TouchableOpacity>
    </View>
  );
}
